import type { ValidationValueMessage } from 'react-hook-form';

export const mapBooleanValueMessage = (
  valueMessage: string | boolean | ValidationValueMessage<boolean> | undefined
): boolean | undefined => {
  if (valueMessage === undefined) {
    return undefined;
  }
  if (typeof valueMessage === 'string' || typeof valueMessage === 'boolean') {
    return Boolean(valueMessage);
  }
  return valueMessage.value;
};

export const mapNumberValueMessage = (
  valueMessage: string | number | ValidationValueMessage<string | number> | undefined
): number | undefined => {
  if (valueMessage === undefined) {
    return undefined;
  }
  if (typeof valueMessage === 'string' || typeof valueMessage === 'number') {
    return Number(valueMessage);
  }
  return Number(valueMessage.value);
};
